
export default {
  name: "MetaFaturamento",

  props: {
    // Você pode passar um objeto completo (ex.: { data: { meta, atingido, percentual } } ou direto { meta, atingido, percentual })
    dados: { type: Object, default: null },

    // Ou passar campos simples diretamente
    meta: { type: [Number, String], default: null },
    atingido: { type: [Number, String], default: null },
    percentual: { type: [Number, String], default: null },

    // Controle de loading vindo do pai (padrão igual aos outros)
    loading: { type: Boolean, default: false },

    // Aparência do gráfico circular
    size: { type: Number, default: 110 },
    stroke: { type: Number, default: 10 },
  },

  computed: {
    // Normaliza as fontes (dados > data > props simples)
    metaValue() {
      if (this.dados?.data?.meta != null) return Number(this.dados.data.meta);
      if (this.dados?.meta != null) return Number(this.dados.meta);
      if (this.meta != null) return Number(this.meta);
      return 0;
    },
    atingidoValue() {
      if (this.dados?.data?.atingido != null)
        return Number(this.dados.data.atingido);
      if (this.dados?.atingido != null) return Number(this.dados.atingido);
      if (this.atingido != null) return Number(this.atingido);
      return 0;
    },
    percentNumber() {
      if (this.dados?.data?.percentual != null)
        return Number(this.dados.data.percentual);
      if (this.dados?.percentual != null) return Number(this.dados.percentual);
      if (this.percentual != null) return Number(this.percentual);
      // fallback: calcula localmente se tiver meta/atingido
      if (this.metaValue > 0)
        return (this.atingidoValue / this.metaValue) * 100;
      return 0;
    },
    displayPercent() {
      const n = isFinite(this.percentNumber) ? this.percentNumber : 0;
      // duas casas, vírgula e símbolo %
      return `${n.toFixed(2).replace(".", ",")}%`;
    },

    // Desenho do círculo
    raio() {
      return (this.size - this.stroke) / 2;
    },
    center() {
      return this.size / 2;
    },
    circunferencia() {
      return 2 * Math.PI * this.raio;
    },
    dashOffset() {
      const pct = Math.max(0, Math.min(100, this.percentNumber));
      return this.circunferencia - (pct / 100) * this.circunferencia;
    },
  },

  methods: {
    toCurrency(value) {
      try {
        return new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        }).format(Number(value) || 0);
      } catch {
        const num = Number(value || 0)
          .toFixed(2)
          .replace(".", ",");
        return `R$ ${num}`;
      }
    },
  },
};
